export default __webpack_public_path__ + "static/media/photo--lg--rambo-1.4ea16e6b.jpg";